export default __webpack_public_path__ + "static/char-v-06-11b83c7a383610e4f5a2f1ef13c53bf5.png";